import styled, { css } from 'styled-components';
// import ArrowDownIcon from 'mdi-react/ChevronDownIcon';
import { IconChevronDown } from '@prisjakt/ui/icon';
import { ThemeType } from 'src/components/base/styles/themes/default';
import { NudgeUp } from '@prisjakt/ui/hideable/variants';
import { Grow, Variant } from './types';

const borderSize = 1;

const dropdownBorder = (
  props: { theme: ThemeType } & SharedProps,
  transparent: boolean = false
) => {
  return `${borderSize}px solid ${
    transparent
      ? 'transparent'
      : props.theme.dropdowns[props.variant].borderColor.active
  }`;
};

export const sharedButtonStyles = {
  cursor: 'pointer',
};

type SharedProps = {
  expanded: boolean;
  variant: Variant;
};

type DropdownProps = {} & SharedProps;

export const Dropdown = styled.div<DropdownProps>(
  props => css`
    position: relative;
    border: ${dropdownBorder(props)};
    border-bottom: ${props.expanded && props.variant === 'primary'
      ? dropdownBorder(props, true)
      : dropdownBorder(props)};
    border-top-left-radius: ${props.theme.dropdowns[props.variant]
      .borderRadius};
    border-top-right-radius: ${props.theme.dropdowns[props.variant]
      .borderRadius};
    border-bottom-left-radius: ${props.expanded
      ? 0
      : props.theme.dropdowns[props.variant].borderRadius};
    border-bottom-right-radius: ${props.expanded
      ? 0
      : props.theme.dropdowns[props.variant].borderRadius};

    color: ${props.theme.icons.tertiary};

    ${props.variant === 'secondary' &&
      css`
        svg,
        path {
          fill: currentColor;
        }

        border-color: transparent;

        &:hover {
          & > button {
            color: ${props.theme.icons.callToAction};
          }
        }

        & > button {
          color: ${props.expanded ? props.theme.icons.callToAction : undefined};
        }
      `};

    ${props.variant !== 'secondary' &&
      css`
        border-color: ${props.expanded
          ? props.theme.dropdowns[props.variant].borderColor.active
          : props.theme.dropdowns[props.variant].borderColor.inactive};

        background: ${props.expanded
          ? props.theme.dropdowns[props.variant].bg
          : 'transparent'};
      `};

    .dropdown-toggle-element {
      &:hover {
        color: ${p => p.theme.buttons.link.textHover};
      }
    }
  `
);

export const DropdownHideable = styled(NudgeUp)`
  position: relative;
  z-index: 11;
`;

type DropdownContentProps = {
  grow: Grow;
} & SharedProps;

export const DropdownContent = styled.div<DropdownContentProps>(
  props => css`
    display: block; /* display flex + absolute position breaks in IE11 */
    position: absolute;
    border: ${dropdownBorder(props)};
    border-top: ${props.expanded && props.variant === 'primary'
      ? dropdownBorder(props, true)
      : dropdownBorder(props)};
    background: ${props.theme.dropdowns[props.variant].bg};
    border-top-left-radius: ${props.expanded
      ? 0
      : props.theme.dropdowns[props.variant].borderRadius};
    border-top-right-radius: ${props.expanded
      ? 0
      : props.theme.dropdowns[props.variant].borderRadius};
    border-bottom-left-radius: ${props.theme.dropdowns[props.variant]
      .borderRadius};
    border-bottom-right-radius: ${props.theme.dropdowns[props.variant]
      .borderRadius};

    ${props.grow === 'right' &&
      css`
        top: calc(100% - 2px);
        left: -${borderSize}px;
      `};

    ${props.grow === 'left' &&
      css`
        top: calc(100% - 2px);
        right: -${borderSize}px;
      `};

    ${props.grow === 'none' &&
      css`
        top: calc(100% - 2px);
        left: -${borderSize}px;
        right: -${borderSize}px;
      `};
  `
);

const arrowStyles = css`
  margin-left: auto;
`;

type ArrowProps = {
  expanded: number;
};

export const Arrow = styled(IconChevronDown)<ArrowProps>`
  ${arrowStyles}

  && {
    transform: ${p => (p.expanded ? 'rotate(180deg)' : 'rotate(0)')};
  }
`;
